import { useState } from 'react';
import { ContactConversationData, ContactFormData } from '../services/contactService';
import ContactService from '../services/contactService';
import { maybeGetRecaptchaToken } from '../utils/recaptchaV3';

interface UseContactProps {
  submitForm: (data: ContactFormData) => Promise<void>;
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  error: Error | null;
  result: ContactConversationData | null;
  reset: () => void;
}

export const useContact = (): UseContactProps => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);
  const [result, setResult] = useState<ContactConversationData | null>(null);

  const submitForm = async (data: ContactFormData): Promise<void> => {
    try {
      setIsLoading(true);
      setIsError(false);
      setError(null);
      setResult(null);
      
      const recaptcha_token = await maybeGetRecaptchaToken('contact_us');
      const response = await ContactService.submitContactForm({ ...data, recaptcha_token });
      setResult(response.data);
      
      setIsSuccess(true);
    } catch (err) {
      setIsError(true);
      const apiMessage = (err as any)?.response?.data?.message;
      setError(new Error(apiMessage || (err as any)?.message || 'Failed to send message.'));
    } finally {
      setIsLoading(false);
    }
  };

  const reset = () => {
    setIsLoading(false);
    setIsSuccess(false);
    setIsError(false);
    setError(null);
  };

  return {
    submitForm,
    isLoading,
    isSuccess,
    isError,
    error,
    result,
    reset
  };
};

export default useContact; 
